<!-- Header -->
<header class="bg-white border-b border-stone-100 sticky top-0 z-50">
  <div class="max-w-[1200px] mx-auto pr-3 sm:pr-8 pl-16 md:pl-5 flex items-center justify-between gap-2 sm:gap-4" style="height: 4.5rem;">
    <!-- Left: Page Title -->
    <div class="flex-1 min-w-0">
      @if (pageTitle()) {
        <h1 class="font-semibold text-base sm:text-lg truncate" [class.text-stone-800]="!isFederationView" [style.color]="isFederationView ? '#334155' : ''">{{ pageTitle() }}</h1>
      }
    </div>

    <!-- Center: Federation Logo -->
    <div class="hidden sm:flex items-center justify-center flex-shrink-0">
      @if (federationLogoUrl) {
        <img [src]="federationLogoUrl" alt="Federation logo" class="h-14 lg:h-16 object-contain" />
      }
    </div>

    <!-- Right: Status & Logout -->
    <div class="flex items-center gap-2 sm:gap-3 flex-shrink-0 sm:flex-1 justify-end">
      @if (accessLevel === 'full') {
        <span class="hidden sm:inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-600 border border-emerald-100">
          <span class="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
          Actif
        </span>
      } @else {
        <span class="inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full bg-amber-50 text-amber-600 border border-amber-100">
          <span class="w-1.5 h-1.5 rounded-full bg-amber-400"></span>
          Lecture seule
        </span>
      }
      <app-notification-bell></app-notification-bell>
      <button
        (click)="logout()"
        aria-label="Déconnexion"
        class="inline-flex items-center justify-center gap-2 min-h-[36px] min-w-[36px] px-2.5 sm:px-3 py-1.5 bg-stone-100 hover:bg-stone-200 text-stone-700 hover:text-stone-900 rounded-lg font-medium text-xs transition-colors"
      >
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
        </svg>
        <span class="hidden sm:inline">Déconnexion</span>
      </button>
    </div>
  </div>
</header>
